import * as React from "react";
import auth from "../../../../Auth";
import { Grid, GridColumn as Column, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { CellRender, GridNoRecord } from "../../../../Shared/GridComponents/CommonComponents";
import CompleteSearch from "../../../../Shared/Search/CompleteSearch";
import ColumnMenu from "../../../../Shared/GridComponents/ColumnMenu";
import RowActions from "../../../../Shared/Workflow/RowActions";
import { CustomMenu, DetailColumnCell, DefaultActions, ViewMoreComponent } from "./GlobalActions";
import { State, toODataString } from "@progress/kendo-data-query";
import { currencyFormatter, downloadExcel, errorToastr, initialDataState, successToastr } from "../../../../../HelperMethods";
import ConfirmationModal from "../../../../Shared/ConfirmationModal";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AppPermissions } from "../../../../Shared/Constants/AppPermissions";
import clientAdminService from "../../Service/DataService";
import { CLIENT_RATE_CARD_REMOVE_SUCCESS_MSG, DOWNLOAD_RATE_CARD_ALERT_MESSAGE, EXCEL_DOWNLOAD_INPROGRESS, INFO_BATCH_RATE_CARD_UPLOAD, REMOVE_CLIENT_RATE_CARD_CONFIRMATION_MSG } from "../../../../Shared/AppMessages";
import { Dialog } from "@progress/kendo-react-dialogs"
import CreateClientRateCard from "../CreateClientRateCard/CreateClientRateCard";
import axios from "axios";
import { KendoFilter } from "../../../../ReusableComponents";
import { Link } from "react-router-dom";
import BreadCrumbs from "../../../../Shared/BreadCrumbs/BreadCrumbs";
import AlertBox from "../../../../Shared/AlertBox";
import includes from 'lodash/includes';
import RateCardHistory from "../Common/RateCardHistory";
import EditClientRateCard from "../CreateClientRateCard/EditClientRateCard";
import { AlertBoxTitle, LocalizationResource } from "../../../../Shared/AppConstants";
import reportServices from "../../../../Shared/Services/ReportServices";
import * as XLSX from 'xlsx';
import { LocalizationHelper } from "../../../../../Localization/helpers/LocalizationHelper";

export interface ClientRateCardProps {
    match: any;
    onCloseModal: any;
}

export interface ClientRateCardState {
    clientId?: string;
    data: any;
    onFirstLoad: boolean;
    totalCount?: number;
    totalClientRatecard?: any;
    showLoader?: boolean;
    showAddNewClientRateCardModal?: boolean;
    showEditModal?: boolean;
    showRemoveModal?: boolean;
    dataState: any;
    rateCardTemplateData: any;
    fileArray?: any[];
    openAlert: boolean;
    totalRatesProcessed?: any;
    rejectedCount?: any;
    date?: Date;
    showRateHistoryModal?: boolean;
}

const allowedMymeTypes = [
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];

const allowedFileExtentions = ["xls", "xlsx"];

class ClientRateCard extends React.Component<ClientRateCardProps, ClientRateCardState> {
    public dataItem: any;
    public alertTitle;
    uploadControl: HTMLInputElement;
    alertMessage: any;
    constructor(props: ClientRateCardProps) {
        super(props);
        this.state = {
            clientId: auth.getClient(),
            data: [],
            dataState: initialDataState,
            onFirstLoad: true,
            showLoader: true,
            rateCardTemplateData: [],
            fileArray: [],
            openAlert: false,
            date: new Date()
        };
    }

    getClientRateCard = (dataState) => {
        var todaysDate = this.state.date.toISOString().substring(0, 10);
        this.setState({ showLoader: true, onFirstLoad: false });
        var queryStr = `${toODataString(dataState)}`;
        let queryParams = `clientId eq ${this.state.clientId} and (validTo ge ${todaysDate} or validTo eq null)`;

        var finalQueryString = KendoFilter(dataState, queryStr, queryParams);

        if (dataState?.filter === null || dataState?.filter === undefined || dataState?.filter.filters.length === 0) {
            this.setState({
                data: [],
                showLoader: false,
                totalCount: 0
            });
        }
        else{
            axios.get(`api/admin/ratecards?${`$count=true&`}${finalQueryString}&$orderby=modifiedDate desc`).then((res) => {
                this.setState({
                    data: res.data.items,
                    showLoader: false,
                    dataState: dataState,
                    totalCount: res.data.count
                });
            });
        }
    }

    deleteClientRateCard = (rateCardId) => {
        this.setState({ showRemoveModal: false });
        clientAdminService.deleteClientRateCard(rateCardId).then((res) => {
            successToastr(CLIENT_RATE_CARD_REMOVE_SUCCESS_MSG);
            this.getClientRateCard(this.state.dataState);
            this.dataItem = undefined;
        });
    };

    handleActionClick = (action, actionId, rowId, nextStateId?, eventName?, dataItem?) => {
        let change = {};
        let property = `show${action.replace(/ +/g, "").replace(".", "")}Modal`;
        change[property] = true;
        this.setState(change);
        this.dataItem = dataItem;
    }

    expandChange = (dataItem) => {
        const { data } = this.state;
        const rateCardData = data.map((item) => {
          if (item === dataItem) {
            item.expanded = !item.expanded;
          }
          return item;
        });

        this.setState({
          data: rateCardData
        });
    };

    onDataStateChange = (changeEvent) => {
        this.getClientRateCard(changeEvent.dataState);
        localStorage.setItem("ManageClientRateCard-GridDataState", JSON.stringify(changeEvent.dataState));
    };

    ExpandCell = (props) => <DetailColumnCell {...props} expandChange={this.expandChange.bind(this)} />;

    AddNewModal = () => {
        this.dataItem = undefined
        this.setState({ showAddNewClientRateCardModal: true })
    }

    downloadTemplate = () => {
        const dataState = initialDataState;
        var finalState: State = {
            ...dataState,
            take: null,
            skip: 0,
        };
        // if (this.state.data && this.state.data.length > 0){
            var queryStr = `${toODataString(finalState)}`;
            let queryParams = `clientId eq ${this.state.clientId}`;
            var finalQueryString = KendoFilter(dataState, queryStr, queryParams);
            clientAdminService.getClientRateCardTemplate(finalQueryString)
            .then((res: any) => {
                if (res) {
                    let fileExt = ".xlsx";
                    let fileType = "application";
                    const linkSource = `data:${fileType}/${fileExt};base64,${res.data}`;
                    const downloadLink = document.createElement("a");
                    let fileName = "RateCardBatchUpload.xlsx";
                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                    this.alertMessage = DOWNLOAD_RATE_CARD_ALERT_MESSAGE;
                    this.alertTitle = AlertBoxTitle.RATE_CARD_BATCH_UPLOAD_ALERT;
                    this.setState({ openAlert: true });
                }
            });
        // }
    }
    
    select = (event) => {
        if (event.target.files.length > 0) {
            let file = event.target.files[0];
            if (includes(allowedMymeTypes, file.type)) {
                this.createNewExcel(event, true);
            } else if (file.type == "") {
                if (includes(allowedFileExtentions, file.name.split(".")[1])) {
                    this.createNewExcel(event, true);
                }
            }
        }
    }

    createNewExcel = (event,isfileValid) => {
        let fileArray = [...this.state.fileArray];
        let file = event.target.files[0];
        let reader = new FileReader();
        reader.onload = (event) => {
            let data = new Uint8Array(event.target.result as ArrayBuffer);
            let workbook = XLSX.read(data, { type: 'array', cellStyles: false });
            let newWorkbook = XLSX.utils.book_new();
            workbook.SheetNames.forEach(sheetName => {
                let worksheet = workbook.Sheets[sheetName];
                let jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: "" });
                let rowData = jsonData.map(row => Object.values(row));
                let newWorksheet = XLSX.utils.aoa_to_sheet(rowData);
                XLSX.utils.book_append_sheet(newWorkbook, newWorksheet, sheetName);
            }); 
            let newFile = new Blob([XLSX.write(newWorkbook, { bookType: 'xlsx', type: 'array' })], { type: 'application/octet-stream' });
            fileArray.push({ fileName: 'new_' + file.name, file: newFile, isValid: isfileValid, path: undefined });
            this.importDocuments(fileArray);
        };
        reader.readAsArrayBuffer(file);
    };
         
    importDocuments = (fileArray) => {
        let checkNewFile = fileArray !== undefined ? fileArray.filter((i) => i.isValid === true) : [];
        if (checkNewFile.length > 0) {
            let formData = new FormData();
            checkNewFile.map((item) => {
                formData.append("FormFiles", item.file);
            });
            axios
                .post(`/api/admin/ratecards/import`, formData)
                .then((response) => response)
                .then((res) => {
                    if (res) {

                        if (res.data.file){
                            let fileExt = ".xlsx";
                            let fileType = "application";
            
                            const linkSource = `data:${fileType}/${fileExt};base64,${res.data.file}`;
                            const downloadLink = document.createElement("a");
                            let fileName = "ManageRateCardErrorList.xlsx";
            
                            downloadLink.href = linkSource;
                            downloadLink.download = fileName;
                            downloadLink.click();
                        }
                        
                        successToastr("Batch Import Completed!");

                        this.setState({
                            totalRatesProcessed: res.data.totalCount,
                            rejectedCount: res.data.rejectedCount,
                        }, () => { this.alertMessage = INFO_BATCH_RATE_CARD_UPLOAD(this.state.totalRatesProcessed, this.state.rejectedCount); this.alertTitle = AlertBoxTitle.RATE_CARD_UPLOAD_ALERT; this.setState({ openAlert: true }); })
                    }

                    this.getClientRateCard(this.state.dataState);
                })
                .catch(() => {
                    this.setState({showLoader: false});
                });
        }
    }

    downloadClientRateCardExcel = () => {
        if(this.state.data.length === 0){
            errorToastr("Use Advanced Search to display and export records.");
            return;
        }
        var finalState: State = {
          ...this.state.dataState,
          take: null,
          skip: 0,
        };
        successToastr(EXCEL_DOWNLOAD_INPROGRESS);
        reportServices.getClientRateCardExcel(this.state.clientId, finalState, this.state.date).then((res: any) => {
            if (res) {
                downloadExcel("Manage Client Rate Card.xlsx", res.data);
            }
        });
      }

    render() {
        return (
            <div className="col-11 mx-auto pl-0 pr-0 mt-3  mt-md-0">
                <div className="container-fluid mt-3 mb-3 d-md-block d-none">
                    <div className="row pt-2 pb-2 mt-3 accordianTitleClr mx-auto mb-2">
                        <div className="col-10 fonFifteen paddingLeftandRight">
                        <BreadCrumbs></BreadCrumbs>
                        </div>
                        <div className="col-2">
                            {auth.hasPermissionV2(AppPermissions.CLIENT_RATE_CARD_CREATE) && (
                                <Link to="/admin/clientratecard/create">
                                    <span className="float-right text-dark">
                                        <FontAwesomeIcon icon={faPlusCircle} className={"mr-1 text-dark"} />
                                        Add New Rate
                                    </span>
                                </Link>
                            )}
                        </div>
                    </div>
                </div>

                <div className="container-fluid">
                    <CompleteSearch
                        page="ManageClientRateCard"
                        entityType={"Client Rate Card"}
                        placeholder="Search text here!"
                        handleSearch={this.getClientRateCard}
                        onFirstLoad={this.state.onFirstLoad}
                        persistSearchData={true}
                    />
                    <div className="manageClientRateCardContainer global-action-grid">
                        <Grid
                            style={{ height: "auto" }}
                            sortable={true}
                            onDataStateChange={this.onDataStateChange}
                            pageable={{ pageSizes: true }}
                            data={this.state.data}
                            {...this.state.dataState}
                            detail={ViewMoreComponent}
                            expandField="expanded"
                            total={this.state.totalCount}
                            className="kendo-grid-custom k-widget lastchild"
                        >
                            <GridNoRecords>{GridNoRecord(this.state.showLoader, null, true)}</GridNoRecords>

                            <GridColumn
                                field="client"
                                title="Client"
                                cell={(props) => CellRender(props, "Client")}
                                columnMenu={ColumnMenu}
                                filter="text"
                            />
                            <GridColumn
                                field="region"
                                width={100}
                                title="Region"
                                columnMenu={ColumnMenu}
                                cell={(props) => CellRender(props, "Region")}
                            />
                            <GridColumn
                                field="division"
                                title="Division"
                                columnMenu={ColumnMenu}
                                cell={(props) => CellRender(props, "Division")}
                                filter="text"
                            />
                            <GridColumn
                                field="location"
                                title={LocalizationHelper.getLocalizedTitle(LocalizationResource.Location_Label, "Location")}
                                columnMenu={ColumnMenu}
                                cell={(props) => CellRender(props, "Location")}
                                filter="text"
                            />
                            <GridColumn
                                field="position"
                                title="Position"
                                columnMenu={ColumnMenu}
                                cell={(props) => CellRender(props, "Position")}
                                filter="text"
                            />
                            <GridColumn
                                field="serviceType"
                                title="Service Type"
                                columnMenu={ColumnMenu}
                                cell={(props) => CellRender(props, "Service Type")}
                                filter="text"
                                width="140px"
                            />
                            <GridColumn
                                field="billType"
                                title="Bill Type"
                                columnMenu={ColumnMenu}
                                cell={(props) => CellRender(props, "Bill Type")}
                                filter="text"
                                width="100px"
                            />
                            <GridColumn
                                field="maxBillRate"
                                title="Max Bill Rate"
                                headerClassName="text-right pr-4"
                                columnMenu={ColumnMenu}
                                cell={(props) => {
                                    return (
                                        <td contextMenu="Max Bill Rate"
                                            className="pr-4 text-right"
                                            title={props.dataItem.maxBillRate}
                                        >
                                            {currencyFormatter(props.dataItem.maxBillRate)}
                                        </td>
                                    );
                                }}
                                width="120px"
                                filter="numeric"
                            />
                            <GridColumn
                                field="validFrom"
                                filter="date"
                                format="{0:d}"
                                editor="date"
                                title="Valid From"
                                columnMenu={ColumnMenu}
                                cell={(props) => CellRender(props, "Valid From")}
                                width="100px"
                            />
                            <GridColumn
                                field="validTo"
                                filter="date"
                                format="{0:d}"
                                editor="date"
                                title="Valid To"
                                columnMenu={ColumnMenu}
                                cell={(props) => CellRender(props, "Valid To")}
                                width="100px"
                            />
                            <GridColumn
                                title="Action"
                                sortable={false}
                                width="50px"
                                cell={(props) => (
                                    <RowActions
                                        dataItem={props.dataItem}
                                        currentState={""}
                                        rowId={props.dataItem.clientDivId}
                                        handleClick={this.handleActionClick}
                                        defaultActions={DefaultActions(props)}
                                    />
                                )}
                                headerCell={() => CustomMenu(this.downloadClientRateCardExcel, this.select, this.downloadTemplate, this.uploadControl)}
                            />
                            <GridColumn sortable={false} field="expanded" width="100px" title="View More" cell={this.ExpandCell} />
                        </Grid>
                    </div>
                </div>

                <ConfirmationModal
                    message={REMOVE_CLIENT_RATE_CARD_CONFIRMATION_MSG()}
                    showModal={this.state.showRemoveModal}
                    handleYes={() => this.deleteClientRateCard(this.dataItem.rateCardId)}
                    handleNo={() => {
                        this.setState({ showRemoveModal: false });
                    }}
                />

                {this.state.showAddNewClientRateCardModal && (
                    <div id="add-ClientRateCard">
                        <Dialog className="col-12 For-all-responsive-height">
                            <CreateClientRateCard
                                props={this.dataItem}
                                onCloseModal={() => this.setState({ showAddNewClientRateCardModal: false }, () => { this.dataItem = undefined; this.getClientRateCard(this.state.dataState) })}
                                onOpenModal={() => this.setState({ showAddNewClientRateCardModal: true })}
                            />
                        </Dialog>
                    </div>
                )}

                {this.state.showEditModal && (
                    <div id="Edit-ClientRateCard">
                        <Dialog className="col-12 For-all-responsive-height">
                            <EditClientRateCard
                                props={this.dataItem}
                                onCloseModal={() => this.setState({ showEditModal: false }, () => { this.dataItem = undefined; this.getClientRateCard(this.state.dataState) })}
                                onOpenModal={() => this.setState({ showEditModal: false })}
                            />
                        </Dialog>
                    </div>
                )}

                {this.state.openAlert &&
                    <AlertBox
                        handleNo={() => { this.setState({ openAlert: false }) }}
                        message={this.alertMessage}
                        showModal={this.state.openAlert}
                        title={this.alertTitle ? this.alertTitle : null}
                    ></AlertBox>
                }
                
                {this.state.showRateHistoryModal && (
                    <div id="hold-position">
                        <Dialog className="col-12 width For-all-responsive-height">
                            <RateCardHistory
                                dataItem={this.dataItem}
                                handleClose={() =>
                                    this.setState({ showRateHistoryModal: false })
                                }
                            ></RateCardHistory>
                        </Dialog>
                    </div>
                )}
            </div>
        );
    }
}

export default ClientRateCard;